import { Avatar, Grid, InputAdornment } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import CustomTextField from "../../../components/Form/CustomTextField"
import CustomSelect from "../../../components/Form/CustomSelect"

const AddAdminModal = ({ open, close, submit, isEdit = false, error, roleList, formObj, setFormObj }) => {

    const handleFormObjChange = (key, value) => {
        let temp = { ...formObj };
        temp[key] = value;
        setFormObj(temp);
    }

    const handleClose = () => {
        if (isEdit) {
            setFormObj({});
        }
        close();
    }
    
    return (
        <AppDialog
            open={open}
            title={isEdit ? "Edit admin" : "New admin"}
            close={() => { handleClose() }}
            positiveTitle={isEdit ? 'Save changes' : 'Save'}
            positivePress={() => submit(formObj)}
            cancelButton={true}
            width={'40%'}
        >
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Name'}
                        placeholder={'Name'}
                        values={formObj?.name}
                        onChange={(e) => handleFormObjChange('name', e)}
                        error={error?.name}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Email Address'}
                        placeholder={'Email Address'}
                        values={formObj?.email}
                        onChange={(e) => handleFormObjChange('email', e)}
                        disabled={isEdit ? true : false}
                        error={error?.email}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Phone Number (optional)'}
                        prefix="+60"
                        values={formObj?.phone}
                        onChange={(e) => handleFormObjChange('phone', e)}
                        placeholder="Phone Number"
                        type={'number'}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><div style={{ borderRight: '1px solid #E6E6E6', paddingInline: 10, color: '#101010' }}>+60</div></InputAdornment>,
                        }}
                        error={error?.phone}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomSelect
                        title={'Role'}
                        values={formObj?.role_id || '-1'}
                        onChange={(e) => handleFormObjChange('role_id', e)}
                        data={roleList || []}
                        labelName={'name'}
                        valueName={'id'}
                        placeholder={'Select role'}
                        error={error?.role_id}
                    />
                </Grid>
            </Grid>
        </AppDialog>
    )
}
export default AddAdminModal;